import { sanitizePayload } from '../utils/sanitize';

const API_BASE = process.env.REACT_APP_API_BASE || 'https://figazuresql.swancreate.com/api/crm';

async function request(url, options = {}) {
  const config = {
    headers: { 'Content-Type': 'application/json' },
    ...options,
  };

  console.log(`[API] ${config.method || 'GET'} ${url}`);

  try {
    const response = await fetch(url, config);
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`[API] Error ${response.status}:`, errorText);
      throw new Error(`API Error ${response.status}: ${errorText}`);
    }
    const data = await response.json();
    console.log(`[API] Success:`, url);
    return data;
  } catch (error) {
    console.error(`[API] Request failed:`, error);
    throw error;
  }
}

export const api = {
  get: (endpoint) => request(`${API_BASE}/${endpoint}`),
  getById: (endpoint, id) => request(`${API_BASE}/${endpoint}/${id}`),
  post: (endpoint, body) => request(`${API_BASE}/${endpoint}`, {
    method: 'POST',
    body: JSON.stringify(sanitizePayload(body)),
  }),
  put: (endpoint, id, body) => {
    const { apiid, ...rest } = sanitizePayload(body);
    return request(`${API_BASE}/${endpoint}/${id}`, {
      method: 'PUT',
      body: JSON.stringify(rest),
    });
  },
  patch: (endpoint, id, body) => {
    const { apiid, ...rest } = sanitizePayload(body);
    return request(`${API_BASE}/${endpoint}/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(rest),
    });
  },
  delete: (endpoint, id) => request(`${API_BASE}/${endpoint}/${id}`, {
    method: 'DELETE',
  }),
  getUrl: (url) => request(url),
  postUrl: (url, body) => request(url, {
    method: 'POST',
    body: JSON.stringify(sanitizePayload(body)),
  }),
};

export default api;
